import { createContext } from "react";

import { IAuthContext } from "../types/contexts";

export const AuthContext = createContext<IAuthContext | null>(null);
